<template>
  <div class="bottom-menu bottom-menu--contrast">
    <div v-for="(item, i) in menuItems"
         :key="i"
         class="bottom-menu__item"
         :class="{'bottom-menu__item--active': item.link === pathname || (item.link === urlLanguagePrefix + /catalog/ && isCatalog) || (item.link === urlLanguagePrefix + /cabinet/ && isCabinet)}">
      <component
        :is="item.type === 'link' ? 'a' : 'button'"
        v-bind="item.type === 'link' ? { href: item.link } : ''"
        v-on="item.type === 'button' ? { click: item.action } : ''"
        :class="{
          'bottom-menu__link': item.type === 'link',
          'bottom-menu__button': item.type === 'button'
        }"
      >
        <div class="bottom-menu__img-wrap">
          <component
            :is="item.iconType === 'svg' ? 'svg' : 'img'"
            v-bind="item.iconType === 'image' ? { src: item.icon, alt: item.title } : { width: 24, height: 24, fill: 'none' }"
            class="bottom-menu__img"
            :class="[
              item.modification ? 'bottom-menu__img--' + item.modification : '',
              item.iconType ? 'bottom-menu__img--' + item.iconType : ''
            ]"
          >
            <use v-if="item.iconType === 'svg'" :xlink:href="spritePath + item.icon"></use>
          </component>
          <span v-if="item.items" class="bottom-menu__counter">{{ item.items }}</span>
        </div>
        <span class="bottom-menu__title">{{ item.title || "&nbsp;" }}</span>
      </component>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { spritePath } from '@/mixins/spritePath'

export default {
  name: 'BottomMenu',
  mixins: [spritePath],
  data () {
    return {
      pathname: window.location.pathname,
      isCatalog: window.isCatalog,
      isCabinet: window.isCabinet
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'cartSort', 'productsToComparison', 'cartModalName']),
    ...mapGetters('wishlist', ['wishlistQuantity']),
    ...mapState({
      user: state => state.user
    }),
    menuItems () {
      return [
        {
          type: 'link',
          link: this.urlLanguagePrefix + '/',
          icon: (this.pathname === this.urlLanguagePrefix + '/') ? '#bottom-menu-main-filled' : '#bottom-menu-main',
          iconType: 'svg',
          title: this.$t('bottom-menu-main') // 'Главная'
        },
        {
          type: 'link',
          link: this.urlLanguagePrefix + '/catalog/',
          icon: '#bottom-menu-catalog',
          iconType: 'svg',
          title: this.$t('bottom-menu-catalog') // 'Каталог',
        },
        {
          type: 'button',
          action: this.openCart,
          icon: '#bottom-menu-cart',
          iconType: 'svg',
          title: this.$t('bottom-menu-cart'), // 'Корзина',
          items: this.cartSort.cart['cartQuantity']
        },
        {
          type: 'link',
          link: this.urlLanguagePrefix + '/hot-sale/',
          icon: '#bottom-menu-sale',
          iconType: 'svg',
          title: this.$t('bottom-menu-sale') // 'Акции',
        },
        {
          type: this.user && this.user.auth ? 'link' : 'button',
          link: this.urlLanguagePrefix + '/cabinet/',
          action: () => this.openAuth(this.urlLanguagePrefix + '/cabinet/'),
          icon: this.user && this.user.auth && this.user.user_data ? this.user.user_data.avatar : '#bottom-menu-profile',
          iconType: this.user && this.user.auth && this.user.user_data ? 'image' : 'svg',
          title: this.$t('bottom-menu-cabinet'), // 'Профиль',
          modification: this.user && this.user.auth ? 'round' : ''
        }
      ]
    }
  },
  methods: {
    openCart () {
      this.$modal.show(this.cartModalName)
    },
    openAuth (url) {
      this.$modal.show('auth-modal', { url })
    }
  }
}
</script>

<style scoped lang="sass">

.bottom-menu
  position: fixed
  bottom: 0
  width: 100%
  display: flex
  flex-flow: row nowrap
  background: #FFFFFF
  z-index: 4
  border-top: 1px solid $nd-border-color
  height: auto

  +mmin($tablet--hor)
    display: none

  &--hide
    height: 0

.bottom-menu__item
  width: 20%
  padding: 6px 0 13px

  &--active
    .bottom-menu__title,
    .bottom-menu__img
      opacity: 1

.bottom-menu__link,
.bottom-menu__button
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  flex-flow: column
  color: $text-color

.bottom-menu__title
  display: block
  margin: 5px 0 0
  font-size: 11px
  height: 14.3px
  color: $text-color
  opacity: .5

.bottom-menu__img-wrap
  position: relative

.bottom-menu__img
  display: block
  width: 24px
  height: 24px
  object-fit: cover
  opacity: .5

  &--round
    border-radius: 50%

  &--svg
    color: $text-color
    fill: $text-color

.bottom-menu__counter
  display: inline-block
  width: 19px
  position: absolute
  top: -5px
  right: -7px
  color: $white-text-color
  font-size: 10px
  line-height: 15px
  text-align: center
  border-radius: 50%
  border: 2px solid $white-text-color
  background-color: $main-color

.bottom-menu__button
  background-color: transparent
  border: 0

.bottom-menu--contrast
  .bottom-menu__title
    opacity: 1

  .bottom-menu__img
    opacity: 1

  .bottom-menu__item--active
    .bottom-menu__title
      color: $main-color

    .bottom-menu__img--svg
      color: $main-color
      fill: $main-color
</style>
